import {
  canManageRiskAndOppProcess,
  isRiskAndOppAdmin,
} from "../../constants/riskAndOpportunityRoles";

export const filterProcessByRole = (roleList, list) => {
  if (isRiskAndOppAdmin(roleList)) return list;

  return list.filter((item) =>
    canManageRiskAndOppProcess(roleList, item.value)
  );
};
